module.exports = __webpack_public_path__ + "img/macbook.dbb8ad0b.svg";